import { InvalidFieldError } from '../../validation/errors/invalid-field-error'
import { type FieldValidation } from '../../validation/protocols/field-validation'
import { type ValidateEmailAdapter } from '../../validation/protocols/validate-email-adapter'

export class EmailValidation implements FieldValidation {
  private readonly validateEmailAdapter: ValidateEmailAdapter
  readonly field: string

  constructor (field: string, validateEmailAdapter: ValidateEmailAdapter) {
    this.field = field
    this.validateEmailAdapter = validateEmailAdapter
  }

  validate (value: string): Error | null {
    const isValid = this.validateEmailAdapter.validate(value)
    return isValid ? null : new InvalidFieldError('email')
  }
}
